import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { checkPageTitle } from '../../../../store/actions/authentication';
import Routes from '../../routes';

import { IButton } from '../../../../styles/styles';

const DocumentTypeMain: React.FC = (props: any) => {
  const publicUrl = process.env.PUBLIC_URL;

  useEffect(() => {
    checkPageTitle(props);
  },[props])
  
  return (
    <React.Fragment>
      <Link to={`${publicUrl}/document-type/create`}>
        <IButton width={100}>NOVO</IButton>
      </Link>
      <Link to={'/document-type/list'}>
        <IButton width={210}>TIPOS DE DOCUMENTOS</IButton>
      </Link>
      <Routes />
    </React.Fragment>
  )
}

export default DocumentTypeMain;